export enum IFrameMessageTypes {
  TaxonomyCatalogUrlPath = 'TaxonomyCatalogUrlPath',
  TaxonomyCatalogKibanna = 'TaxonomyCatalogKibanna',
  DataDictionaryUrlPath = 'DataDictionaryUrlPath',
  TaxonomyCatalogFeatureFlags = 'TaxonomyCatalogFeatureFlags',
  TaxonomyCatalogBrand = 'TaxonomyCatalogBrand',
}

export const WILSON_CLIENT_NAMES = new Set([
  'Wilson HR',
  'Wilson HCG',
  'Wilson_SuperUsers',
]);
